/* eslint-disable react/prop-types */
import React from "react";
import Registration from "./Registration";
import TelegramLogin from "./Telegram";
import config from "../../config";

const RegistrationWrapper = (props) => {
	const showTelegram =
		typeof window !== "undefined" &&
		window.location.hostname in config.telegramLogin &&
		(window.location.hostname === "dev.wintomato.com" || window.location.hostname === "localhost");
	return (
		<div className="registrationWrapper">
			<Registration match={props.match} />
			{showTelegram && (
				<>
					<div className="block tg tgram" style={{ height: "45px" }}>
						<TelegramLogin />
					</div>
				</>
			)}
		</div>
	);
};
export default RegistrationWrapper;
